export default "__VITE_ASSET__ZWu95hb___"